import { brandAndCountryFromZone } from '@seek/audience-zones';
import { getLanguageFromLocale } from '@seek/melways-sites';

import {
  COUNTRY,
  LANGUAGE,
  ZONE,
} from 'src/app/shared/constants/configObjectProperties';
import { LANGUAGE_LOCALE_DEFAULT } from 'src/app/shared/constants/language';
import { SITE_SECTION, SUB_SECTION } from 'src/app/shared/constants/tealium';
import { getConfig } from 'src/app/utils/config';
import type { Tealium } from 'src/types/appState';
import { TealiumContractType, TealiumPricingType } from 'src/types/tealium';

export default (tealium: Tealium) => {
  const {
    advertiser,
    cajaFlowType,
    draftId,
    hirerContract,
    hirerInfo,
    page,
    seekAdvertiserId,
    userId,
  } = tealium;

  // TO-DO: Analytics require brand to be seek, jobsDb and jobstreet
  // depending on site. This is temporary and needs to be cleaned up post unification
  // For all hirer sites regardless of which doamin, should have brand as 'seek'
  const [brand] = brandAndCountryFromZone(getConfig(ZONE)) || [];

  const language = getLanguageFromLocale(
    getConfig(LANGUAGE, LANGUAGE_LOCALE_DEFAULT),
  );

  return {
    advertiserCommitmentType: advertiser?.type ?? TealiumContractType.Casual,
    advertiserContractAdType: hirerContract?.adType,
    advertiserContractBalance: hirerContract?.balance,
    advertiserContractType: hirerContract?.type,
    advertiserContractValue: hirerContract?.value,
    brand,
    currentPage: page ? page.replace('-', ' ') : '',
    zone: getConfig(ZONE),
    cajaFlowType,
    adDraftId: draftId,
    hirerUserEmail: hirerInfo?.emailAddress ?? '',
    hirerUserFullName: `${hirerInfo?.firstName} ${hirerInfo?.lastName}`,
    pricingType: advertiser?.pricingType ?? TealiumPricingType.Variable,
    seekAdvertiserId,
    siteCountry: getConfig(COUNTRY).toLowerCase(),
    siteLanguage: language,
    siteSection: SITE_SECTION,
    siteSubSection: SUB_SECTION,
    userId,
  };
};
